import { render, staticRenderFns } from "./Afiliate.vue?vue&type=template&id=364aad94&scoped=true&lang=pug&"
import script from "./Afiliate.vue?vue&type=script&lang=js&"
export * from "./Afiliate.vue?vue&type=script&lang=js&"
import style0 from "./Afiliate.vue?vue&type=style&index=0&id=364aad94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364aad94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364aad94')) {
      api.createRecord('364aad94', component.options)
    } else {
      api.reload('364aad94', component.options)
    }
    module.hot.accept("./Afiliate.vue?vue&type=template&id=364aad94&scoped=true&lang=pug&", function () {
      api.rerender('364aad94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autoservice/Afiliate.vue"
export default component.exports